"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _Theme = _interopRequireDefault(require("../../Theme"));

var _MobileDropDownOption = _interopRequireDefault(require("../MobileDropDownOption"));

var _MobileDropdownOptions = require("./MobileDropdownOptions.propTypes");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2.default)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var MobileDropdownOptions = function MobileDropdownOptions(props) {
  var options = props.options,
      optionsConfig = props.optionsConfig,
      markSelectedOnPress = props.markSelectedOnPress,
      selectedItem = props.selectedItem,
      theme = props.theme,
      customProperties = props.customProperties;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var handlePress = function handlePress(value) {
    markSelectedOnPress(value);
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, options && // eslint-disable-next-line react/prop-types
    options.map(function (option, index) {
      return /*#__PURE__*/_react.default.createElement(_MobileDropDownOption.default, (0, _extends2.default)({}, option, optionsConfig, {
        onOptionPress: handlePress,
        key: option.value,
        itemSelected: option.value === selectedItem,
        theme: theme,
        customProperties: _objectSpread({
          id: "mobile-dropdown-option-".concat(index)
        }, customProperties)
      }));
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

MobileDropdownOptions.propTypes = _MobileDropdownOptions.MobileDropdownOptionsPropTypes.PropTypes;
MobileDropdownOptions.defaultProps = _MobileDropdownOptions.MobileDropdownOptionsPropTypes.DefaultProps;
var _default = MobileDropdownOptions;
exports.default = _default;